module.exports = __webpack_public_path__ + "static/media/LogoOficial.0bba3baa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/LogoOficial.png
// module id = 155
// module chunks = 0